import { CertificationSettingId } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/types.ts';

/** The certification toggle each proof toggle owns. */
const CERTIFICATION_BY_PROOF: Partial<Record<string, CertificationSettingId>> = {
	proofOfIdentityRequired: 'proofOfIdentityCertificationRequired',
	proofOfAddressRequired: 'proofOfAddressCertificationRequired',
	proofOfInvestmentVehicleRequired: 'proofOfInvestmentVehicleCertificationRequired',
};

/**
 * The certification toggle that moves with `id`, and the value it moves to. Certification is
 * meaningless without the proof it certifies, so switching a proof off switches it off. Switching a
 * proof on does not switch it back on — certification is opt-in, and asking for a certified copy is
 * a separate choice. Mirrors `resolveOne` in the kycSetting repository, and is sent in the same
 * request as the proof so the settings hooks — which cache only the fields they sent — stay in step
 * with what was written.
 */
export const certificationToggleFollowing = (
	id: string,
	newValue: boolean
): { id: CertificationSettingId; value: boolean } | undefined => {
	const certificationId = CERTIFICATION_BY_PROOF[id];
	return certificationId && !newValue ? { id: certificationId, value: false } : undefined;
};
